module.exports = __webpack_public_path__ + "img/left-to-line.7ce3a2ea.svg";